import GetLoading from "../../share/getLoading";
import React, { useEffect, useState, useRef } from "react";
import ExcelJS from "exceljs";
import * as FileSaver from "file-saver";
// import { Html5QrcodeScanner } from "html5-qrcode";
import {
  Button,
  DatePicker,
  Table,
  Space,
  Input,
  Tag,
  Modal,
  Card,
  Avatar,
  TimePicker,
  Select,
  Tabs,
  Checkbox
} from "antd";
import { request } from "../../share/request";
import dayjs from "dayjs";
import moment from "moment";
import {
  formateDateClient,
  formateDateSystem,
  linkPath,
  linkPathIDCard,
  timeGeneratorScan,
} from "../../share/helper";
import { getCurrentUser, getPermission } from "../../share/getProfile";
import {
  PlusCircleOutlined,
  CloseOutlined,
  FilterOutlined,
  UserOutlined,
  CalendarOutlined,        // ← ADD THIS
  BankOutlined,            // ← ADD THIS
  TeamOutlined,            // ← ADD THIS
  InfoCircleOutlined,      // ← ADD THIS
  ClearOutlined,           // ← ADD THIS
  CheckCircleOutlined,     // ← ADD THIS
  CheckCircleFilled,
  CloseCircleFilled,
  DownloadOutlined,
  FileExcelOutlined,
  CalculatorOutlined,
  ThunderboltOutlined,
} from "@ant-design/icons";

import style from "../../styles/style.module.css";
import "../../styles/StyleAttendance.css";
import { Pagination } from "antd";
import { BsDownload } from "react-icons/bs";
import { boxHeader, boxHeaderTagText } from "../../styles/boxShadow";
import { openNotification } from "../../share/message";
import isoWeek from "dayjs/plugin/isoWeek";
import AttendanceImport from "./ImportAttandanceMachine";
import StaffList from "../../component/list/StaffList";
import DepartmentList from "../../component/list/DepartmentList";
const { TabPane } = Tabs;  // ← ADD THIS
const { Option } = Select;
// Function to calculate distance between two coordinates using Haversine formula
function getDistance(lat1, lon1, lat2, lon2) {
  const R = 6371; // Radius of the Earth in kilometers
  const dLat = (lat2 - lat1) * (Math.PI / 180);
  const dLon = (lon2 - lon1) * (Math.PI / 180);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * (Math.PI / 180)) *
    Math.cos(lat2 * (Math.PI / 180)) *
    Math.sin(dLon / 2) *
    Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c; // Distance in kilometers
  return distance;
}

const AttendanceQRCode = ({
  filter_id_dept,
  GetUserName,
  GetIdnumber,
  txtSearchVisable,
  btn_add,
}) => {
  const format = "HH:mm";
  const [Org_ImagePath, SetOrgImagePath] = useState(
    "https://www.pngkit.com/png/full/981-9818240_your-logo-retulp-bus-stop.png"
  );
  const [list_staff, setList_staff] = useState([]);
  const getProfile = getCurrentUser();
  const [totalPage, setTotalPage] = useState(null);
  const [model, setModel] = useState(false);
  const [model_invalid_link, setModel_invalid_link] = useState(false);
  const metor = 0.05;
  const [result, setResult] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const userProfile = getCurrentUser();
  const [currentPage, setCurrentPage] = useState(1);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [userBrowserLat, setUserBrowserLat] = useState(0);
  const [userBrowserLng, setUserBrowserLng] = useState(0);
  const [distanceValue, setDistanceValue] = useState(0);
  const [showReader, setShowReader] = useState(true); // State to control reader visibility
  const [showReaderInvalidQRCode, setShowReaderInvalidQRCode] = useState(true); // State to show invalid QR code modal
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openModel, setOpenModel] = useState(false);
  const searchTimeoutRef = useRef(null);
  const [UserDateStart, setUserDateStart] = useState(null);
  const [UserDateEnd, setUserDateEnd] = useState(null);
  const [listAttendanceByWeekend, setListAttendanceByWeekend] = useState([]);
  const [username, setUserName] = useState("");
  const [staffname, setStaffName] = useState("");
  const [visableModelAttendance, setVisableModelAttendance] = useState(false);
  const [tiem_Value, setTimeValue] = useState(null);
  const { Option } = Select;
  const [userdate_attandance, setUserdate_attandance] = useState(null);
  const itemsPerPage = 10;
  const [listFinal, setListFinal] = useState([]);
  const [DownloadReport, setDownloadReport] = useState(false);
  const [ListExcelData, setListExcelData] = useState([]);
  const [selectedDateStart, setSelectedDate_start] = useState(dayjs);
  const [selectedDateEnd, setSelectedDate_end] = useState(dayjs);
  // Extend dayjs with isoWeek plugin
  // ====== ADD THESE NEW STATE VARIABLES ======
  const [downloadSelectedDepartments, setDownloadSelectedDepartments] = useState([]);
  const [downloadSelectedStaff, setDownloadSelectedStaff] = useState([]);
  const [activeDownloadTab, setActiveDownloadTab] = useState("1");
  const [excludeWeekendA, setExcludeWeekendA] = useState(false);
  // ===========================================
  dayjs.extend(isoWeek);

  const getStartAndEndOfWeek = () => {
    // Start of the week (Monday)
    const startOfWeek = dayjs().startOf("isoWeek"); // ISO weeks start on Monday
    // End of the week (Sunday)
    const endOfWeek = dayjs().endOf("isoWeek");

    return {
      start: startOfWeek.format("YYYY-MM-DD"),
      end: endOfWeek.format("YYYY-MM-DD"),
    };
  };

  const getImageLinkOrganization = async () => {
    const param = new URLSearchParams({ org_code: getProfile.org_code });
    try {
      const res = await request(
        "settingorgidcard?" + param.toString(),
        "get",
        {}
      );
      if (res && res.list_api) {
        const logoProfile = res.list_api.find((item) => item.param === "logo");
        if (logoProfile) {
          SetOrgImagePath(linkPathIDCard + logoProfile.imagelink);
        }
      }
    } catch (error) {
      console.error("Failed to fetch organization images:", error);
    }
  };

  // // date of week
  // const getStartAndEndOfWeek = () => {
  //   // Start of the week (Monday)
  //   const startOfWeek = dayjs().startOf("week").add(1, "day"); // dayjs starts week on Sunday by default
  //   // End of the week (Sunday)
  //   const endOfWeek = dayjs().endOf("week").add(1, "day");

  //   return {
  //     start: startOfWeek.format("YYYY-MM-DD"),
  //     end: endOfWeek.format("YYYY-MM-DD"),
  //   };
  // };
  const { start, end } = getStartAndEndOfWeek();
  // search data in db
  const [objFilter, setObjFilter] = useState({
    page: 1,
    txtSearch: "",
    d_start: UserDateStart || start,
    d_end: UserDateEnd || end,
    // d_start: "2024-11-06",
    // d_end: "2024-11-10",
    org_code: userProfile.org_code,
    username: GetUserName === undefined ? "" : GetUserName,
  });
  // -----------------  permisstion page --------------------
  const userPermission = getPermission();
  const AttendancePageValue = userPermission.find(
    (permission) => permission.pagename === "attendance"
  ) || { add: 0, edit: 0, deleted: 0, print: 0 };
  const {
    add: addvalue,
    edit: Editvalue,
    deleted: deletevalue,
    print: printValue,
  } = AttendancePageValue;
  // -----------------  end permisstion page --------------------
  const pagesizeIndex = 10;
  const [filteredDataSource, setFilteredDataSource] = useState([]);

  const getListEmployee = async () => {
    if (!getProfile?.org_code) {
      console.error("Organization code is missing");
      return;
    }

    const param = new URLSearchParams({
      org_code: getProfile.org_code,
    });

    try {
      const res = await request(`leavestaff?${param.toString()}`, "get", {});
      if (res && res.list_staff) {
        setList_staff(res.list_staff);
      } else {
        console.warn("No staff list returned from the response.");
      }
    } catch (error) {
      console.error("Error fetching employee list:", error);
    }
  };
  const onChangeStaff = (value) => {
    setUserName(value);
    setStaffName(value);
    console.log("onChangeStaff', value:", username);
  };
  const getList = async (ParamObjFilter) => {
    console.log("parsing list 1: ", objFilter);
    // create function success
    try {
      const params = new URLSearchParams({
        page: ParamObjFilter.page,
        txtSearch: ParamObjFilter.txtSearch,
        d_start: ParamObjFilter.d_start,
        d_end: ParamObjFilter.d_end,
        org_code: ParamObjFilter.org_code,
        username: ParamObjFilter.username,
      });
      setLoading(true);
      await new Promise((resolve) => setTimeout(resolve, 400));
      const res = await request(
        "attendanceqrcode?" + params.toString(),
        "get",
        {}
      );
      if (res && res.list) {
        if (ParamObjFilter.txtSearch) {
          console.log("Filtered Data:", res.list);
          setFilteredDataSource(res.list[0]);
          setListAttendanceByWeekend(res.api_DataWeekend[1]);
          setListFinal(res.api_datefinal[0]);
        } else {
          console.log("Non-Filtered Data:", res.list);
          setFilteredDataSource(res.list[0]);
          setListAttendanceByWeekend(res.api_DataWeekend[1]);
          setListFinal(res.api_datefinal[0]);
        }
        if (
          res &&
          res.list &&
          Array.isArray(res.list[1]) &&
          res.list[1].length > 0
        ) {
          const firstItem = res.list[1][0]; // Accessing the first item from the nested array
          if (firstItem && firstItem.total !== undefined) {
            const totalItems = firstItem.total;
            console.log("Total Items:", totalItems);
            setTotalPage(totalItems);
          } else {
            console.log("Error: 'total' property not found or undefined.");
            // Handle the case where 'total' property is missing or undefined
          }
        } else {
          console.log("Error: Invalid response structure or empty array.");
          // Handle other error scenarios related to response structure
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getImageLinkOrganization();
    console.log(" loading image path:", Org_ImagePath);
    getListEmployee();
    getList(objFilter);
    console.log("param search :", objFilter);
  }, []);

  // for reader qrcode wep // do not delete tthis code
  //   useEffect(() => {
  //     getList();
  //     if (showReader && showReaderInvalidQRCode) {
  //       let scanner = null;
  //       const onScanSuccess = (googleMapsLink) => {
  //         setResult(googleMapsLink);
  //         setIsLoading(true);
  //         scanner.clear();
  //         extractLatLng(googleMapsLink);
  //       };
  //       const onScanError = (error) => {
  //         console.error("QR error:", error);
  //       };
  //       scanner = new Html5QrcodeScanner("reader", {
  //         fps: 10,
  //         qrbox: {
  //           width: 250,
  //           height: 250,
  //         },
  //       });
  //       scanner.render(onScanSuccess, onScanError);
  //       return () => {
  //         if (scanner) {
  //           scanner.clear();
  //         }
  //       };
  //     } else {
  //       setShowReader(true);
  //       setShowReaderInvalidQRCode(true);
  //     }
  //   }, [latitude, longitude, distanceValue, showReader, showReaderInvalidQRCode]);

  const extractLatLng = (googleMapsLink) => {
    const regex = /@(-?\d+\.\d+),(-?\d+\.\d+)/;
    const match = googleMapsLink.match(regex);
    if (match && match.length >= 3) {
      const lat = parseFloat(match[1]);
      const lng = parseFloat(match[2]);
      setLatitude(lat);
      setLongitude(lng);
      handleSaveAttendance(lat, lng);
    } else {
      setShowReaderInvalidQRCode(true);
      setModel_invalid_link(true);
      setIsLoading(false);
    }
  };

  const handleSaveAttendance = async (latQR, lngQR) => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        async function (position) {
          setUserBrowserLat(position.coords.latitude);
          setUserBrowserLng(position.coords.longitude);
          await new Promise((resolve) => setTimeout(resolve, 400));
          const distance = getDistance(
            latQR,
            lngQR,
            position.coords.latitude,
            position.coords.longitude
          );
          setDistanceValue(distance);
          if (distance <= metor) {
            const data = {
              staff_code: userProfile.username,
              staff_name: userProfile.fullname,
              scan_date: formateDateSystem(),
              scan_time: timeGeneratorScan(),
            };
            try {
              const res = await request("attendanceqrcode", "post", data);
              console.log("Save Attendance:", res);
            } catch (error) {
              console.error("Error saving attendance:", error);
            } finally {
              setIsLoading(false);
              setModel(true);
              setShowReader(true);
              setShowReaderInvalidQRCode(true);
            }
          } else {
            console.log("QR code location is too far from current location.");
            setIsLoading(false);
            setModel(true);
          }
        },
        function (error) {
          console.error("Error getting location:", error);
        }
      );
    } else {
      console.log("Geolocation is not supported in this browser.");
    }
  };
  const handleCLoseInvalidLinkModal = () => {
    setModel_invalid_link(false);
    setShowReaderInvalidQRCode(true);
  };

  // const onChangePage = async (page) => {
  //   try {
  //     setLoading(true);
  //     var objTmp = {
  //       ...objFilter,
  //       page: page,
  //     };
  //     await new Promise((resolve) => setTimeout(resolve, 400));
  //     await setObjFilter(objTmp);
  //     getList(objTmp);
  //   } catch (error) {
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSearchInputChange = (event) => {
    const inputValue = event.target.value;
    setCurrentPage(1);

    // Clear the existing timeout if user is still typing
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    // Set a new timeout for 3 seconds
    searchTimeoutRef.current = setTimeout(() => {
      onSearch(inputValue);
    }, 3000);
  };

  const onSearch = (value) => {
    var objTmp = {
      ...objFilter,
      txtSearch: value == "" || null ? "" : value,
      page: value === "" ? 1 : objFilter.page,
    };
    setObjFilter(objTmp);
    getList(objTmp);
  };
  const timeScan = (timeString) => {
    // Assuming timeString format is "###" (e.g., "123")
    if (!timeString) return ""; // Handle empty timeString case

    // Extract hours and minutes from the timeString
    const hours = Math.floor(timeString / 100); // Extract hours (e.g., 123 -> 1)
    const minutes = timeString % 100; // Extract minutes (e.g., 123 -> 23)

    // Determine AM/PM and format hours and minutes
    const period = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12; // Convert hours to 12-hour format

    // Construct formatted time string (e.g., "1:23 PM")
    const formattedTime = `${formattedHours}:${minutes
      .toString()
      .padStart(2, "0")} ${period}`;
    return formattedTime;
  };
  function getRandomColor() {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  // Define common styles outside the JSX
  const commonStyle = {
    justifyContent: "center",
    alignItems: "start",
    height: 20,
    fontSize: 4,
    borderRadius: 5,
    padding: "0 5px",
    margin: 2,
  };

  const textStyle = {
    margin: 2,
    fontWeight: "bold",
    color: "white",
  };
  const createDayColumn = (
    key,
    title,
    dataIndex,
    listFinal,
    getRandomColor,
    fixed
  ) => ({
    key,
    title,
    dataIndex,
    fixed,

    render: (value, record) => {
      // Determine if there is any data for this day
      if (!value) {
        return <div style={{ textAlign: "center", color: "#ccc" }}>-</div>;
      }

      // Format from backend: Morning|07:45 AM|11:30 AM;;Evening|01:30 PM|05:45 PM
      let shifts = [];
      const shiftStrings = value.split(";;");
      shifts = shiftStrings.map((str) => {
        const parts = str.split("|");
        return {
          name: parts[0] || "Unknown",
          inTime: parts[1] && parts[1] !== "null" ? parts[1] : null,
          outTime: parts[2] && parts[2] !== "null" ? parts[2] : null,
        };
      });

      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            width: "auto",
            minWidth: "130px",
          }}
        >
          {shifts.map((shift, i) => (
            <div key={i} style={{ display: "flex", flexDirection: "column", paddingBottom: i < shifts.length - 1 ? "6px" : "0", borderBottom: i < shifts.length - 1 ? "1px dashed #e8e8e8" : "none" }}>
              <div style={{ textAlign: "left", fontSize: "12px", fontWeight: "bold", color: "#555", marginBottom: "4px", fontFamily: "Khmer OS Battambang, sans-serif" }}>
                {shift.name}
              </div>
              <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center", gap: "6px" }}>
                <div style={{ display: "flex", alignItems: "center", fontSize: "10px", whiteSpace: "nowrap", color: shift.inTime ? "#135200" : "#a8071a", backgroundColor: shift.inTime ? "#d9f7be" : "#fff1f0", padding: "2px 6px", borderRadius: "4px", border: shift.inTime ? "1px solid #b7eb8f" : "1px solid #ffa39e" }}>
                  {shift.inTime ? (
                    <><CheckCircleFilled style={{ color: "#52c41a", marginRight: "4px" }} /> {shift.inTime}</>
                  ) : (
                    <><CloseCircleFilled style={{ color: "#ff4d4f", marginRight: "4px" }} /> No In</>
                  )}
                </div>
                <span style={{ color: "#ccc" }}>-</span>
                <div style={{ display: "flex", alignItems: "center", fontSize: "10px", whiteSpace: "nowrap", color: shift.outTime ? "#135200" : "#a8071a", backgroundColor: shift.outTime ? "#d9f7be" : "#fff1f0", padding: "2px 6px", borderRadius: "4px", border: shift.outTime ? "1px solid #b7eb8f" : "1px solid #ffa39e" }}>
                  {shift.outTime ? (
                    <><CheckCircleFilled style={{ color: "#52c41a", marginRight: "4px" }} /> {shift.outTime}</>
                  ) : (
                    <><CloseCircleFilled style={{ color: "#ff4d4f", marginRight: "4px" }} /> No Out</>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      );
    },
  });

  const getDayDate = (dayOffset) => {
    if (!objFilter || !objFilter.d_start) return "";
    // objFilter.d_start contains the actual date string used to fetch data (either default or user selected)
    const monday = dayjs(objFilter.d_start).startOf("week").add(1, "day");
    return monday.add(dayOffset, "day").format("DD/MM");
  };

  const daysOfWeek = [
    { key: "Monday", title: <div style={{ textAlign: 'center', fontFamily: 'Khmer OS Battambang, sans-serif' }}>ច័ន្ទ | Mon<br />{getDayDate(0)}</div> },
    { key: "Tuesday", title: <div style={{ textAlign: 'center', fontFamily: 'Khmer OS Battambang, sans-serif' }}>អង្គារ៍ | Tue<br />{getDayDate(1)}</div> },
    { key: "Wednesday", title: <div style={{ textAlign: 'center', fontFamily: 'Khmer OS Battambang, sans-serif' }}>ពុធ | Wed<br />{getDayDate(2)}</div> },
    { key: "Thursday", title: <div style={{ textAlign: 'center', fontFamily: 'Khmer OS Battambang, sans-serif' }}>ព្រហ | Thu<br />{getDayDate(3)}</div> },
    { key: "Friday", title: <div style={{ textAlign: 'center', fontFamily: 'Khmer OS Battambang, sans-serif' }}>សុក្រ | Fri<br />{getDayDate(4)}</div> },
    { key: "Saturday", title: <div style={{ textAlign: 'center', fontFamily: 'Khmer OS Battambang, sans-serif' }}>សៅរ៍ | Sat<br />{getDayDate(5)}</div> },
    { key: "Sunday", title: <div style={{ textAlign: 'center', fontFamily: 'Khmer OS Battambang, sans-serif' }}>អាទិត្យ | Sun<br />{getDayDate(6)}</div> },
  ];

  const weekColumns = daysOfWeek.map((day) =>
    createDayColumn(day.key, day.title, day.key, listFinal, getRandomColor, day.key === 'Sunday' ? 'right' : undefined)
  );
  const columns = [
    {
      key: "id",
      title: <div style={{ fontFamily: 'Khmer OS Battambang, sans-serif' }}>ល.រ</div>,
      dataIndex: "id",

      render: (value, item, index) =>
        index + 1 + itemsPerPage * (objFilter.page - 1),
    },
    {
      key: "idnumber",
      title: <div style={{ fontFamily: 'Khmer OS Battambang, sans-serif' }}>ពត៍មានបុគ្គលិក</div>,
      dataIndex: "idnumber",
      render: (text, record, index) => {
        return (
          <div
            style={{
              width: 250,
              margin: "5px",
              borderRadius: "8px",
              backgroundColor: "",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            }}
          >
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={{ padding: 10 }}>
                {/* Display avatar from staff_info or image */}
                <Avatar
                  size={60}
                  src={
                    (() => {
                      // Check if staff_info exists and has image
                      if (record.staff_info) {
                        try {
                          const staffData = typeof record.staff_info === 'string'
                            ? JSON.parse(record.staff_info)
                            : record.staff_info;
                          if (Array.isArray(staffData) && staffData.length > 0 && staffData[0].image) {
                            return `${linkPath}${staffData[0].image}`;
                          }
                        } catch (e) {
                          console.error('Error parsing staff_info:', e);
                        }
                      }
                      // Fallback to direct image field
                      console.log("Avatar debug:", { image: record.image, linkPath: linkPath, finalUrl: record.image ? `${linkPath}${record.image}` : null });
                      return record.image ? `${linkPath}${record.image}` : null;
                    })()
                  }
                  icon={<UserOutlined />}
                  style={{
                    border: '2px solid #f0f0f0',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                  }}
                  onError={() => {
                    console.error('Failed to load image for:', record.fullname);
                    return false;
                  }}
                />
              </div>
              <div style={{ padding: 10, fontWeight: "bold", color: "gray", fontFamily: 'Khmer OS Battambang, sans-serif' }}>
                {record.fullname}
                <div style={{ fontWeight: "normal", fontSize: "12px", marginTop: "4px" }}>
                  {record.position}
                </div>
              </div>
            </div>
          </div>
        );
      },
    },
    ...weekColumns,
  ];
  // for old
  // const columns = [
  //   {
  //     key: "id",
  //     title: "ល.រ",
  //     dataIndex: "id",

  //     render: (value, item, index) =>
  //       index + 1 + itemsPerPage * (objFilter.page - 1),
  //   },

  //   {
  //     key: "idnumber",
  //     title: "ពត៍មានបុគ្គលិក",
  //     dataIndex: "idnumber",
  //     render: (text, record, index) => {
  //       return (
  //         <div
  //           style={{
  //             width: 250,

  //             margin: "5px",
  //             borderRadius: "8px",
  //             backgroundColor: "",
  //             boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  //           }}
  //         >
  //           <div style={{ display: "flex", flexDirection: "row" }}>
  //             <div style={{ padding: 10 }}>
  //               <Avatar
  //                 size={60}
  //                 icon={<UserOutlined />}
  //                 style={{ marginBottom: 16 }}
  //               />
  //             </div>
  //             <div style={{ padding: 10, fontWeight: "bold", color: "gray" }}>
  //               {record.fullname}
  //               <div>
  //                 {record.department} | {record.position}
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     key: "Monday",
  //     title: "ថ្ងៃច័ន្ទ | Mon",
  //     dataIndex: "Monday",
  //     render: (value, record) => {
  //       const times = value ? value.split(", ") : [];

  //       // Calculate the start of the current week (Monday)
  //       const today = dayjs();
  //       const startOfWeek = today.startOf("week").add(1, "day"); // Monday
  //       const endOfWeek = startOfWeek.add(6, "days"); // Sunday

  //       // Filter listFinal for the current week and Monday
  //       const matchingItem = listFinal.filter((item) => {
  //         const scanDate = dayjs(item.scan_date); // Parse scan_date
  //         return (
  //           scanDate.isSame(startOfWeek, "date") && // Ensure it's Monday
  //           item.user_id === record.idnumber // Match idnumber
  //         );
  //       })[0]; // Get the first match if available

  //       const percent = matchingItem
  //         ? `${Math.round(matchingItem.total_percent)}%`
  //         : "N/A";
  //       const work_minute = matchingItem
  //         ? matchingItem.fullday_total_minute_work
  //         : "N/A";
  //       const work_status = matchingItem ? matchingItem.arrival_status : "N/A";

  //       return (
  //         <div style={{ display: "flex", flexDirection: "row", width: 130 }}>
  //           <div>
  //             {times &&
  //               Array.isArray(times) &&
  //               times.map((time, index) => (
  //                 <Tag
  //                   key={index}
  //                   color={getRandomColor()}
  //                   style={{
  //                     marginBottom: "5px",
  //                     borderRadius: 20,
  //                     fontWeight: "bold",
  //                   }}
  //                 >
  //                   {time}
  //                 </Tag>
  //               ))}
  //           </div>
  //           <div style={{ display: "flex", flexDirection: "column" }}>
  //             {[
  //               { value: `${percent}`, bgColor: getRandomColor() },
  //               { value: `${work_minute}m`, bgColor: getRandomColor() },
  //               { value: `${work_status}`, bgColor: getRandomColor() },
  //             ].map((item, index) => (
  //               <div
  //                 key={index}
  //                 style={{
  //                   ...commonStyle,
  //                   backgroundColor: item.bgColor,
  //                 }}
  //               >
  //                 <p style={textStyle}>{item.value}</p>
  //               </div>
  //             ))}
  //           </div>
  //         </div>
  //       );
  //     },
  //   },

  //   {
  //     key: "Tuesday",
  //     title: "ថ្ងៃអង្គារ៍ | Tue",
  //     dataIndex: "Tuesday",
  //     render: (value) => {
  //       const times = value ? value.split(", ") : [];
  //       // Ensure the value is an array of times and map over it to render tags
  //       return (
  //         <div style={{ display: "flex", flexDirection: "row", width: 130 }}>
  //           <div>
  //             {times &&
  //               Array.isArray(times) &&
  //               times.map((time, index) => (
  //                 <Tag
  //                   key={index}
  //                   color={getRandomColor()}
  //                   style={{
  //                     marginBottom: "5px",
  //                     borderRadius: 20,
  //                     fontWeight: "bold",
  //                   }}
  //                 >
  //                   {time}
  //                 </Tag>
  //               ))}
  //           </div>
  //           <div
  //             style={{
  //               display: "flex",
  //               justifyContent: "center", // Aligns children (the <p> tag) horizontally
  //               alignItems: "center", // Aligns children vertically
  //               backgroundColor: getRandomColor(),
  //               height: 25,
  //               borderRadius: 20,
  //               padding: "0 5px", // Optional: Add some padding if needed
  //             }}
  //           >
  //             <p style={{ margin: 2, fontWeight: "bold", color: "white" }}>
  //               100%
  //             </p>
  //             {/* Remove margin to ensure perfect centering */}
  //           </div>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     key: "Wednesday",
  //     title: "ថ្ងៃពុធ | Wed",
  //     dataIndex: "Wednesday",
  //     render: (value) => {
  //       const times = value ? value.split(", ") : [];
  //       // Ensure the value is an array of times and map over it to render tags
  //       return (
  //         <div style={{ display: "flex", flexDirection: "row", width: 130 }}>
  //           <div>
  //             {times &&
  //               Array.isArray(times) &&
  //               times.map((time, index) => (
  //                 <Tag
  //                   key={index}
  //                   color={getRandomColor()}
  //                   style={{
  //                     marginBottom: "5px",
  //                     borderRadius: 20,
  //                     fontWeight: "bold",
  //                   }}
  //                 >
  //                   {time}
  //                 </Tag>
  //               ))}
  //           </div>
  //           <div
  //             style={{
  //               display: "flex",
  //               justifyContent: "center", // Aligns children (the <p> tag) horizontally
  //               alignItems: "center", // Aligns children vertically
  //               backgroundColor: getRandomColor(),
  //               height: 25,
  //               borderRadius: 20,
  //               padding: "0 5px", // Optional: Add some padding if needed
  //             }}
  //           >
  //             <p style={{ margin: 2, fontWeight: "bold", color: "white" }}>
  //               100%
  //             </p>
  //             {/* Remove margin to ensure perfect centering */}
  //           </div>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     key: "Thursday",
  //     title: "ថ្ងៃព្រហ | Thu",
  //     dataIndex: "Thursday",
  //     render: (value) => {
  //       const times = value ? value.split(", ") : [];
  //       // Ensure the value is an array of times and map over it to render tags
  //       return (
  //         <div style={{ display: "flex", flexDirection: "row", width: 130 }}>
  //           <div>
  //             {times &&
  //               Array.isArray(times) &&
  //               times.map((time, index) => (
  //                 <Tag
  //                   key={index}
  //                   color={getRandomColor()}
  //                   style={{
  //                     marginBottom: "5px",
  //                     borderRadius: 20,
  //                     fontWeight: "bold",
  //                   }}
  //                 >
  //                   {time}
  //                 </Tag>
  //               ))}
  //           </div>
  //           <div
  //             style={{
  //               display: "flex",
  //               justifyContent: "center", // Aligns children (the <p> tag) horizontally
  //               alignItems: "center", // Aligns children vertically
  //               backgroundColor: getRandomColor(),
  //               height: 25,
  //               borderRadius: 20,
  //               padding: "0 5px", // Optional: Add some padding if needed
  //             }}
  //           >
  //             <p style={{ margin: 2, fontWeight: "bold", color: "white" }}>
  //               100%
  //             </p>
  //             {/* Remove margin to ensure perfect centering */}
  //           </div>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     key: "Friday",
  //     title: "ថ្ងៃសុក្រ | Fri",
  //     dataIndex: "Friday",
  //     render: (value) => {
  //       const times = value ? value.split(", ") : [];
  //       // Ensure the value is an array of times and map over it to render tags
  //       return (
  //         <div style={{ display: "flex", flexDirection: "row", width: 130 }}>
  //           <div>
  //             {times &&
  //               Array.isArray(times) &&
  //               times.map((time, index) => (
  //                 <Tag
  //                   key={index}
  //                   color={getRandomColor()}
  //                   style={{
  //                     marginBottom: "5px",
  //                     borderRadius: 20,
  //                     fontWeight: "bold",
  //                   }}
  //                 >
  //                   {time}
  //                 </Tag>
  //               ))}
  //           </div>
  //           <div
  //             style={{
  //               display: "flex",
  //               justifyContent: "center", // Aligns children (the <p> tag) horizontally
  //               alignItems: "center", // Aligns children vertically
  //               backgroundColor: getRandomColor(),
  //               height: 25,
  //               borderRadius: 20,
  //               padding: "0 5px", // Optional: Add some padding if needed
  //             }}
  //           >
  //             <p style={{ margin: 2, fontWeight: "bold", color: "white" }}>
  //               100%
  //             </p>
  //             {/* Remove margin to ensure perfect centering */}
  //           </div>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     key: "Saturday",
  //     title: "ថ្ងៃសៅរ៍ | Sat",
  //     dataIndex: "Saturday",
  //     render: (value) => {
  //       const times = value ? value.split(", ") : [];
  //       // Ensure the value is an array of times and map over it to render tags
  //       return (
  //         <div style={{ display: "flex", flexDirection: "row", width: 130 }}>
  //           <div>
  //             {times &&
  //               Array.isArray(times) &&
  //               times.map((time, index) => (
  //                 <Tag
  //                   key={index}
  //                   color={getRandomColor()}
  //                   style={{
  //                     marginBottom: "5px",
  //                     borderRadius: 20,
  //                     fontWeight: "bold",
  //                   }}
  //                 >
  //                   {time}
  //                 </Tag>
  //               ))}
  //           </div>
  //           <div
  //             style={{
  //               display: "flex",
  //               justifyContent: "center", // Aligns children (the <p> tag) horizontally
  //               alignItems: "center", // Aligns children vertically
  //               backgroundColor: getRandomColor(),
  //               height: 25,
  //               borderRadius: 20,
  //               padding: "0 5px", // Optional: Add some padding if needed
  //             }}
  //           >
  //             <p style={{ margin: 2, fontWeight: "bold", color: "white" }}>
  //               100%
  //             </p>
  //             {/* Remove margin to ensure perfect centering */}
  //           </div>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     key: "Sunday",
  //     title: "ថ្ងៃអាទិត្យ | Sun",
  //     dataIndex: "Sunday",
  //     render: (value) => {
  //       const times = value ? value.split(", ") : [];
  //       // Ensure the value is an array of times and map over it to render tags
  //       return (
  //         <div style={{ display: "flex", flexDirection: "row", width: 130 }}>
  //           <div>
  //             {times &&
  //               Array.isArray(times) &&
  //               times.map((time, index) => (
  //                 <Tag
  //                   key={index}
  //                   color={getRandomColor()}
  //                   style={{
  //                     marginBottom: "5px",
  //                     borderRadius: 20,
  //                     fontWeight: "bold",
  //                   }}
  //                 >
  //                   {time}
  //                 </Tag>
  //               ))}
  //           </div>
  //           <div
  //             style={{
  //               display: "flex",
  //               justifyContent: "center", // Aligns children (the <p> tag) horizontally
  //               alignItems: "center", // Aligns children vertically
  //               backgroundColor: getRandomColor(),
  //               height: 25,
  //               borderRadius: 20,
  //               padding: "0 5px", // Optional: Add some padding if needed
  //             }}
  //           >
  //             <p style={{ margin: 2, fontWeight: "bold", color: "white" }}>
  //               100%
  //             </p>
  //             {/* Remove margin to ensure perfect centering */}
  //           </div>
  //         </div>
  //       );
  //     },
  //   },

  //   // {
  //   //   key: "action",
  //   //   title: "សកម្មភាព",
  //   //   dataIndex: "action",
  //   //   render: (value, item, index) => {
  //   //     return (
  //   //       <div>
  //   //         <Space key={index}>
  //   //           <Button
  //   //             type="primary"
  //   //             //  disabled={!Editvalue}
  //   //             //  onClick={() => onOpenModelEdit(item)}
  //   //           >
  //   //             Edit
  //   //           </Button>
  //   //           <Button
  //   //             danger
  //   //             type="primary"
  //   //             //  disabled={!Deletevalue}
  //   //             //  onClick={() => onOpenModelDelete(item)}
  //   //             icon={<CloseOutlined />}
  //   //           />
  //   //         </Space>
  //   //       </div>
  //   //     );
  //   //   },
  //   // },
  // ];

  const onChangePage = async (page) => {
    setLoading(true);
    setCurrentPage(page);
    var objTmp = {
      ...objFilter,
      page: page,
    };
    await setObjFilter(objTmp);
    getList(objTmp);
  };

  const handleFilterClick = () => {
    setOpenModel(true);
  };
  const handleCancel = () => {
    setOpenModel(false);
  };
  const handleApply = async () => {
    console.log(
      "apply handle ",
      UserDateStart?.format("DD/MM/YYYY") +
      " - " +
      UserDateEnd?.format("DD/MM/YYYY")
    );

    try {
      setLoading(true);
      await new Promise((resolve) => setTimeout(resolve, 400));

      var objTmp = {
        ...objFilter,
        d_start: undefined ? null : UserDateStart?.format("YYYY-MM-DD"),
        d_end: undefined ? null : UserDateEnd?.format("YYYY-MM-DD"),
      };
      console.log("new param : ", objTmp);

      setObjFilter(objTmp);
      await getList(objTmp);
      setOpenModel(false); // Close modal after data is fully loaded
    } catch (error) {
      console.error("Error applying filter:", error);
    } finally {
      setLoading(false);
    }
  };

  const OnChangeDate_Start = (date) => {
    setUserDateStart(date); // No need for dayjs parsing, as Antd DatePicker returns dayjs objects
    console.log("OnChangeDate1 ", date?.format("DD/MM/YYYY"));
  };

  const OnChangeDate_End = (date) => {
    setUserDateEnd(date);
    console.log("OnChangeDate2 ", date?.format("DD/MM/YYYY"));
  };

  const onCLickTimeChange = (time, timeString) => {
    console.log("Selected time:", dayjs(time).format("HH:mm")); // This is the Dayjs object representing the selected time
    console.log("Formatted time:", timeString); // This is the formatted time as a string, e.g., "12:00"
    setTimeValue(dayjs(time).format("HH:mm"));
    // You can use `time` or `timeString` as needed
  };
  const handleSaveandUpdate = async () => {
    try {
      setLoading(true);

      const data = {
        staff_code: username,
        staff_name: null, // Assumes no staff name is required, otherwise update this.
        scan_date: dayjs(userdate_attandance).format("YYYY-MM-DD"), // Replace with dynamic date if necessary.
        scan_time: tiem_Value, // Ensure `time_Value` has the correct format, e.g., "HH:mm".
      };
      console.table(data);

      // Make POST request
      const res = await request("attendanceqrcode", "post", data);

      // Handle response
      if (res.success == true) {
        openNotification("success", "Success", "Save attendance successfully!");
      } else {
        openNotification(
          "error",
          "Error",
          res.message || "Failed to save attendance."
        );
      }

      // Refresh the list (assuming `getList` fetches updated data)
    } catch (error) {
      console.error("Error saving attendance:", error);
      openNotification("error", "Error", "An unexpected error occurred.");
    } finally {
      setVisableModelAttendance(false);
      setLoading(false);
      getList(objFilter);
    }
  };

  const onChangeDateAttendance = (date) => {
    setUserdate_attandance(date);
    console.log(" data attancedan: " + userdate_attandance);
  };

  const onExporttoExcel_AttendanceTimeReport = async () => {

    // Determine staff_id based on context
    let staffId = "";
    if (GetIdnumber !== undefined && GetIdnumber !== "" && GetIdnumber !== null) {
      staffId = GetIdnumber; // Single staff from other page
    } else if (downloadSelectedStaff.length > 0) {
      staffId = downloadSelectedStaff.join(","); // Multiple staff from modal
    }

    const param = new URLSearchParams({
      org_code: getProfile.org_code,
      date_start: dayjs(selectedDateStart).format("YYYY-MM-DD"),
      date_end: dayjs(selectedDateEnd).format("YYYY-MM-DD"),
      idnumber: staffId,
      department_id: downloadSelectedDepartments.length > 0 ? downloadSelectedDepartments.join(",") : "",
    });

    console.log("📋 Attendance Report params:", param.toString());
    console.log("👤 Staff IDs:", staffId);
    console.log("🏢 Department IDs:", downloadSelectedDepartments.length > 0 ? downloadSelectedDepartments.join(",") : "ALL");
    try {
      const res = await request(
        `attendancetimereport?` + param.toString(),
        "get",
        {}
      );
      console.log("Full API Response:", res);

      if (res && res.success === true) {
        // Wrap the response in an array if it is not already an array
        const attendanceData = res.api_attendance_time_report[0];
        setListExcelData(res.api_attendance_time_report[0]);
        return attendanceData;
      } else {
        console.error("Invalid response structure or empty data:", res);
        return [];
      }
    } catch (error) {
      console.error("Error fetching data from API:", error);
      return [];
    }
  };
  const convertImageToBase64 = async (imageUrl) => {
    try {
      const response = await fetch(imageUrl, {
        mode: "cors", // Ensure CORS is allowed by the server
      });
      if (!response.ok) {
        throw new Error(`Failed to fetch image. Status: ${response.status}`);
      }

      const blob = await response.blob();
      const base64String = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const result = reader.result.split(",")[1];
          resolve("data:image/png;base64," + result); // Ensure this is correct for your image type
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
      return base64String;
    } catch (error) {
      console.error("Error fetching or converting image:", error);
      throw new Error("Image conversion failed");
    }
  };

  const downloadExcel_monthylyreport = async () => {
    try {
      setLoading(true);
      await new Promise((resolve) => setTimeout(resolve, 400));

      // Fetch data
      const data = (await onExporttoExcel_AttendanceTimeReport()) || [];
      console.log("Processed data for Excel:", data);

      if (data.length === 0) {
        console.warn("No data available for Excel export.");
        return;
      }

      // Load the template Excel file
      const templatePath =
        process.env.PUBLIC_URL + "/template/attendance_time_report.xlsx";
      const response = await fetch(templatePath);

      if (!response.ok) {
        throw new Error(`Failed to load template. Status: ${response.status}`);
      }

      const templateArrayBuffer = await response.arrayBuffer();
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(templateArrayBuffer);

      const dataSheet = workbook.getWorksheet("report");

      // Convert data to worksheet format
      const newData = data.map((item) => Object.values(item));

      // Example: Add organization name and data
      dataSheet.getCell("A3").value =
        getProfile.org_name_kh || "Organization Name";
      dataSheet.getCell("O3").value = getProfile.org_type;
      dataSheet.getCell(
        "A5"
      ).value = `តារាងស្កែនវត្តមានបុគ្គលិក ពីថ្ងៃទី ${dayjs(
        selectedDateStart
      ).format("DD/MM/YYYY")} ដល់ថ្ងៃទី ${dayjs(selectedDateEnd).format(
        "DD/MM/YYYY"
      )}`;
      // Convert and insert the image
      const imageUrl =
        "https://static.vecteezy.com/system/resources/previews/012/986/755/non_2x/abstract-circle-logo-icon-free-png.png";
      const base64Image = await convertImageToBase64(imageUrl);
      console.log("base64Image: ", base64Image);
      // const base64Image = await convertImageToBase64(Org_ImagePath);
      // const extension = Org_ImagePath.split(".").pop().toLowerCase();
      // const mimeType =
      //   extension === "png"
      //     ? "image/png"
      //     : extension === "jpg"
      //     ? "image/jpeg"
      //     : "image/png";

      // console.log("Base64 Image:", base64Image); // Debugging log
      // console.log("Image MIME Type:", mimeType); // Debugging log

      // const imageId = workbook.addImage({
      //   base64: base64Image,
      //   extension: extension,
      //   mimeType: mimeType,
      // });

      // // Position image at cell S3 (column 18, row 3)
      // dataSheet.addImage(imageId, {
      //   tl: { col: 18, row: 3 },
      //   ext: { width: 100, height: 100 },
      // });

      // Add data table
      dataSheet.addTable({
        name: "dataTable1",
        ref: "B9",
        columns: Object.keys(data[0]).map((key) => ({ name: key })),
        rows: newData,
      });

      // Hide unused rows
      const hideRows = (sheet, length) => {
        const startRowToDelete = length + 11;
        const endRowToHide = 1000;
        for (let row = startRowToDelete; row <= endRowToHide; row++) {
          sheet.getRow(row).height = 0.1;
        }
      };
      hideRows(dataSheet, newData.length);

      // Save workbook and trigger download
      const blob = await workbook.xlsx.writeBuffer();
      const name_report = `Attendance-time-Report-${selectedDateStart.format(
        "MM-DD-YYYY"
      )} to ${selectedDateEnd.format("MM-DD-YYYY")} ${moment().format(
        "HH:mm:ss"
      )}`;
      FileSaver.saveAs(new Blob([blob]), `${name_report}.xlsx`);
    } catch (error) {
      console.error("Error during Excel generation:", error);
    } finally {
      setLoading(false);
    }
  };


  // const onExporttoExcel_AttendanceTimeReport_Cal = async () => {
  //   const param = new URLSearchParams({
  //     org_code: getProfile.org_code,
  //     date_start: dayjs(selectedDateStart).format("YYYY-MM-DD"),
  //     date_end: dayjs(selectedDateEnd).format("YYYY-MM-DD"),
  //   });

  //   try {
  //     const res = await request(
  //       `attendancetimereportcalculator?${param.toString()}`,
  //       "get",
  //       {}
  //     );

  //     console.log("Full API Response:", res);

  //     // ✅ MySQL stored procedure result (IMPORTANT)
  //     const rows = res?.api_attendance_time_report?.[0];

  //     if (Array.isArray(rows) && rows.length > 0) {
  //       setListExcelData(rows);
  //       return rows; // ✅ ALWAYS RETURN ARRAY
  //     }

  //     console.error("No valid rows found:", res);
  //     return [];
  //   } catch (error) {
  //     console.error("API error:", error);
  //     return [];
  //   }
  // };
  const onExporttoExcel_AttendanceTimeReport_Cal = async () => {
    const param = new URLSearchParams({
      org_code: getProfile.org_code,
      date_start: dayjs(selectedDateStart).format("YYYY-MM-DD"),
      date_end: dayjs(selectedDateEnd).format("YYYY-MM-DD"),
    });

    try {
      const res = await request(
        `attendancetimereportcalculator?${param.toString()}`,
        "get",
        {}
      );

      console.log("Full API Response:", res);

      const rows = res?.api_attendance_time_report?.[0];

      if (Array.isArray(rows) && rows.length > 0) {
        // Map shift_name and create rang_short
        const mappedRows = rows.map((row) => {
          // Map shift_name
          const shift = row.shift_name?.toLowerCase().trim() || "";
          if (shift.includes("morn")) {
            row.shift_name = "1-Morning";
          } else if (shift.includes("even")) {
            row.shift_name = "2-Evening";
          } // other shifts remain as-is

          // Create rang_short (short fullname)
          if (row.fullname) {
            const names = row.fullname.trim().split(/\s+/);
            row.rang_short = names.map(n => n[0]).join("").toUpperCase(); // initials
          } else {
            row.rang_short = "";
          }

          return row;
        });

        // Sort by department_name, user_code, rang_short, shift_name
        const sortedRows = mappedRows.sort((a, b) => {
          if (a.department_name !== b.department_name) {
            return a.department_name.localeCompare(b.department_name);
          }
          if (a.user_code !== b.user_code) {
            return a.user_code.localeCompare(b.user_code);
          }
          if (a.rang_short !== b.rang_short) {
            return a.rang_short.localeCompare(b.rang_short);
          }
          // shift_name order: Morning -> Evening -> Others
          const shiftOrder = (shift) => {
            if (shift.includes("Morning")) return 1;
            if (shift.includes("Evening")) return 2;
            return 3;
          };
          return shiftOrder(a.shift_name) - shiftOrder(b.shift_name);
        });


        setListExcelData(sortedRows);
        return sortedRows;
      }

      console.error("No valid rows found:", res);
      return [];
    } catch (error) {
      console.error("API error:", error);
      return [];
    }
  };



  const COLUMN_LABELS_KH = {
    department_name: "ផ្នែក",
    user_code: "លេខបុគ្គលិក",
    fullname: "គោត្តនាម និងនាម",
    range: "ឋានៈ",
    position: "មុខតំណែង",
    shift_name: "ប្រភេទពេលម៉ោងធ្វើការ",
    stafftype: "ប្រភេទ",
  };


  const handleDownloadDailyReport = async () => {
    try {
      setLoading(true);

      let staffId = "";
      if (GetIdnumber !== undefined && GetIdnumber !== "" && GetIdnumber !== null) {
        staffId = GetIdnumber; 
      } else if (downloadSelectedStaff.length > 0) {
        staffId = downloadSelectedStaff.join(","); 
      }

      const param = new URLSearchParams({
        org_code: getProfile.org_code,
        date_start: dayjs(selectedDateStart).format("YYYY-MM-DD"),
        date_end: dayjs(selectedDateEnd).format("YYYY-MM-DD"),
        user_ids: staffId,
        department_ids: downloadSelectedDepartments.length > 0 ? downloadSelectedDepartments.join(",") : "",
        txtSearch: objFilter.txtSearch || ""
      });

      const res = await request(`dailyattendancetimereportbydate?${param.toString()}`, "get", {});
      if (res && res.api_attendance_time_report) {
        const data = res.api_attendance_time_report[0] || [];
        
        const reportData = {
          orgName: getProfile.org_name_kh || "",
          orgType: getProfile.org_type || "",
          dateStart: dayjs(selectedDateStart).format("DD/MM/YYYY"),
          dateEnd: dayjs(selectedDateEnd).format("DD/MM/YYYY"),
          data: data
        };

        localStorage.setItem("attendance_daily_report_data", JSON.stringify(reportData));
        const newWindow = window.open("/reports_attendance_daily.html", "_blank");
        if (!newWindow) {
          alert("Please allow popups for this website to view the report.");
        }
      }
    } catch (error) {
      console.error("Error fetching daily report:", error);
      alert("មានបញ្ហាក្នុងការទាញយកទិន្នន័យ");
    } finally {
      setLoading(false);
    }
  };

  const downloadExcel_monthylyreport_calculator = async () => {
    try {
      setLoading(true);

      // 🔹 Fetch data
      const data = await onExporttoExcel_AttendanceTimeReport_Cal();

      if (!Array.isArray(data) || data.length === 0) {
        console.warn("No data available for Excel export.");
        alert("មិនមានទិន្នន័យទេ (No Data)");
        return;
      }

      // 🔹 Sort data: department → stafftype (រដ្ឋ first) → user_rang_short
      const sortedData = [...data].sort((a, b) => {
        // 1️⃣ First, compare by department_name
        const deptA = a.department_name || '';
        const deptB = b.department_name || '';

        const deptCompare = deptA.localeCompare(deptB);
        if (deptCompare !== 0) return deptCompare;

        // 2️⃣ Then, sort by stafftype - "រដ្ឋ" comes first
        const staffA = a.stafftype || '';
        const staffB = b.stafftype || '';

        // Define stafftype priority (រដ្ឋ = 1, others = 2)
        const getStaffPriority = (type) => type === 'រដ្ឋ' ? 1 : 2;
        const staffPriorityA = getStaffPriority(staffA);
        const staffPriorityB = getStaffPriority(staffB);

        const staffCompare = staffPriorityA - staffPriorityB;
        if (staffCompare !== 0) return staffCompare;

        // If both are same stafftype, sort alphabetically
        const staffAlphaCompare = staffA.localeCompare(staffB);
        if (staffAlphaCompare !== 0) return staffAlphaCompare;

        // 3️⃣ Finally, sort by user_rang_short
        const rangA = parseInt(a.range) || 0;
        const rangB = parseInt(b.range) || 0;

        // If rang is same, sort by employee ID to keep same employees together
        if (rangA === rangB) {
          const idA = a['លេខបុគ្គលិក'] || '';
          const idB = b['លេខបុគ្គលិក'] || '';
          return idA.localeCompare(idB);
        }

        return rangA - rangB; // Ascending order (smallest rang first)
      });

      // 🔹 Remove duplicate department_name, stafftype, fullname, and username
      const cleanedData = [];
      let lastDepartment = null;
      let lastStafftype = null;
      let lastFullname = null;
      let lastUsername = null;

      let lastPosition = null;
      let lastRange = null;

      for (const item of sortedData) {
        const newItem = { ...item };

        let departmentChanged = false;

        // department_name duplicates
        if (newItem.department_name === lastDepartment) {
          newItem.department_name = "";
        } else {
          lastDepartment = newItem.department_name;
          departmentChanged = true;
        }

        let fullnameChanged = false;
        // fullname duplicates
        if (newItem.fullname === lastFullname) {
          newItem.fullname = "";
        } else {
          lastFullname = newItem.fullname;
          fullnameChanged = true;
        }

        // stafftype duplicates (merge only if it's the same person)
        if (!fullnameChanged && newItem.stafftype === lastStafftype) {
          newItem.stafftype = "";
        } else {
          lastStafftype = newItem.stafftype;
        }

        // username duplicates (merge only if it's the same person)
        if (!fullnameChanged && newItem.username === lastUsername) {
          newItem.username = "";
        } else {
          lastUsername = newItem.username;
        }

        // position duplicates (merge only if it's the same person)
        if (!fullnameChanged && newItem.position === lastPosition) {
          newItem.position = "";
        } else {
          lastPosition = newItem.position;
        }

        // range duplicates (merge only if it's the same person)
        if (!fullnameChanged && newItem.range === lastRange) {
          newItem.range = "";
        } else {
          lastRange = newItem.range;
        }


        cleanedData.push(newItem);
      }

      // 🔹 Generate HTML Report
      const title = `តារាងស្កែនវត្តមានបុគ្គលិក ពីថ្ងៃទី ${dayjs(selectedDateStart).format("DD/MM/YYYY")} ដល់ថ្ងៃទី ${dayjs(selectedDateEnd).format("DD/MM/YYYY")}`;
      const orgName = getProfile?.org_name_kh || "Organization Name";
      const orgType = getProfile?.org_type || "";

      // 🔹 Keys to exclude
      const excludeKeys = ["showadmin", "user_rang_short", "rang_short", "user_code", "position", "range"];
      let baseKeys = Object.keys(cleanedData[0]).filter(
        (key) => !excludeKeys.includes(key)
      );

      // 🔹 Move 'stafftype' to be before 'shift_name' (ប្រភេទពេលម៉ោងធ្វើការ)
      const staffTypeIndex = baseKeys.indexOf("stafftype");
      if (staffTypeIndex !== -1) {
        baseKeys.splice(staffTypeIndex, 1);
        const shiftNameIndex = baseKeys.indexOf("shift_name");
        if (shiftNameIndex !== -1) {
          baseKeys.splice(shiftNameIndex, 0, "stafftype");
        } else {
          baseKeys.push("stafftype");
        }
      }

      // Add total columns
      const keys = [...baseKeys, "total_L", "total_E", "total_A", "total_M", "total_LF"];

      // 🔹 Columns and Rows
      const weekendIndices = [];
      const columns = keys.map((key, index) => {
        if (key === "total_L") return "សរុប L<br/>(យឺត)";
        if (key === "total_E") return "សរុប E<br/>(ចេញមុន)";
        if (key === "total_A") return "សរុប A<br/>(អវត្តមាន)";
        if (key === "total_M") return "សរុប M<br/>(បេសកកម្ម)";
        if (key === "total_LF") return "សរុប LF<br/>(ច្បាប់ពេញ)";

        let label = COLUMN_LABELS_KH[key] || key;

        // If the key is a date format like DD_MM (e.g., "01_07")
        if (/^\d{2}_\d{2}$/.test(key)) {
          const [d, m] = key.split('_');
          const year = dayjs(selectedDateStart).year();
          const dateObj = dayjs(`${year}-${m}-${d}`);
          if (dateObj.isValid()) {
            const dayIndex = dateObj.day();
            if (dayIndex === 0 || dayIndex === 6) {
              weekendIndices.push(index);
            }

            const khmerDays = ["អាទិត្យ", "ច័ន្ទ", "អង្គារ", "ពុធ", "ព្រហ", "សុក្រ", "សៅរ៍"];
            const dayName = khmerDays[dayIndex];

            // Use Arabic numerals for the date (e.g., 01, 02)
            label = `<div style="text-align: center;">${dayName}<br/>${d}</div>`;
          }
        }

        return label;
      });

      const rows = cleanedData.map((item) => {
        let total_L = 0, total_E = 0, total_A = 0, total_M = 0, total_LF = 0;

        // Calculate totals for this row using only the actual base keys (not the newly added total columns)
        baseKeys.forEach((key, index) => {
          const val = item[key];
          if (typeof val === "string") {
            // split by whitespace, comma, or parenthesis to isolate the letters
            const tokens = val.split(/[\s,()]+/);
            if (tokens.includes("L")) total_L++;
            if (tokens.includes("E")) total_E++;
            if (tokens.includes("A")) {
              if (excludeWeekendA && weekendIndices.includes(index)) {
                // Do not count A on weekends if checkbox is checked
              } else {
                total_A++;
              }
            }
            if (tokens.includes("M")) total_M++;
            if (tokens.includes("LF")) total_LF++;
          }
        });

        return keys.map((key) => {
          if (key === "total_L") return total_L > 0 ? total_L : "";
          if (key === "total_E") return total_E > 0 ? total_E : "";
          if (key === "total_A") return total_A > 0 ? total_A : "";
          if (key === "total_M") return total_M > 0 ? total_M : "";
          if (key === "total_LF") return total_LF > 0 ? total_LF : "";

          if (key === "fullname") {
            const nameStr = item[key] ?? "";
            const posStr = item["position"] ?? "";
            if (nameStr && posStr) {
              return `<b>${nameStr}</b><br/><span style="color: #666; font-weight: normal; font-size: 0.9em;">${posStr}</span>`;
            } else if (nameStr) {
              return `<b>${nameStr}</b>`;
            } else if (posStr) {
              return `<span style="color: #666; font-weight: normal; font-size: 0.9em;">${posStr}</span>`;
            }
            return "";
          }

          return item[key] ?? "";
        });
      });

      // 🔹 Prepare data for reportattendance.html
      const reportData = {
        title,
        orgName,
        orgType,
        keys,
        columns,
        rows,
        weekendIndices,
      };

      // Save to localStorage so the HTML file can access it
      localStorage.setItem("attendance_report_data", JSON.stringify(reportData));

      // 🔹 Open the HTML report in a new tab
      const newWindow = window.open("/reportattendance.html", "_blank");
      if (!newWindow) {
        alert("Please allow popups for this website to view the report.");
      }
    } catch (error) {
      console.error("Error during Excel generation:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleExportExcel = async () => {
    setDownloadReport(true);
  };

  const handleDateChange_Start = (date) => {
    setSelectedDate_start(date);
  };
  const handleDateChange_End = (date) => {
    setSelectedDate_end(date);
  };
  return (
    <div>
      {/* <div style={{ width: "300px", height: "300px", padding: "10px" }}>
        {showReader && <div id="reader"></div>}
        {showReaderInvalidQRCode && <div id="reader"></div>}
        {isLoading && (
          <div className="sprinCustome">
            <GetLoading />
          </div>
        )}
        {latitude !== null && longitude !== null && (
          <Modal
            open={model}
            title={
              distanceValue <= metor
                ? "Attendance Save Successfully"
                : "QR code location is too far from current location."
            }
            footer={
              <Button
                color="primary"
                onClick={() => {
                  setModel(false);
                  setShowReader(true);
                }}
              >
                Close
              </Button>
            }
            onCancel={() => {
              setModel(false);
              setShowReader(true);
            }}
          >
            <p>
              {latitude === 0 && longitude === 0
                ? "Invalid Google Maps link. Please provide a valid link."
                : null}
            </p>
            <p>
              <Result
                status={distanceValue <= metor ? "success" : "warning"}
                title={
                  distanceValue <= metor
                    ? "Attendance Save Successfully"
                    : "QRcode location is too far from current location."
                }
              />
            </p>
          </Modal>
        )}

        <Modal
          open={model_invalid_link}
          title="Invalid QR Code"
          onCancel={handleCLoseInvalidLinkModal}
          footer={null}
        >
          <Result title="Invalid QRCode . Please try to scan with correct QRCode " />
        </Modal>
      </div> */}

      <div style={boxHeader}>
        <div className="Header-Setting-Grid">
          <div className="Header-Setting-Grid-R">
            {boxHeaderTagText("ការគ្រប់គ្រងស្កែនវត្តមានបុគ្គលិក ")}

            <Space>
              <Input
                style={{
                  display: txtSearchVisable ? "none" : "block",
                  width: "200px",
                }}
                className="styleTageStatusForm"
                placeholder="Search..."
                onChange={handleSearchInputChange}
                allowClear
              />
              <div
                style={{
                  backgroundColor: getRandomColor(),
                  padding: "8px",
                  borderRadius: "4px",
                  cursor: "pointer",
                  display: "flex",
                  border: "1px solid gray",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={handleFilterClick} // Add a click handler for filter action
              >
                <FilterOutlined style={{ color: "white", fontSize: "16px" }} />
              </div>
            </Space>
          </div>

          <div>
            <Space>
              <Button
                className="buttonstylekhmer"
                onClick={handleExportExcel}
                type="primary"
                icon={<BsDownload />}
              >
                ទាយយករបាយការណ៍
              </Button>
              {Boolean(addvalue) && (
                <Button
                  style={{
                    display: btn_add ? "none" : "block",
                  }}
                  className="custom-form-item"

                  type="primary"
                  icon={<PlusCircleOutlined />}
                  onClick={() => setVisableModelAttendance(true)}
                >
                  បន្ថែមថ្មី
                </Button>
              )}
            </Space>
          </div>
        </div>
      </div>

      <div style={{ padding: "10px", width: "100%" }}>
        <div>
          {loading ? (
            <div className="sprinCustome">
              <GetLoading />
            </div>
          ) : (
            <Table
              columns={columns}
              dataSource={listAttendanceByWeekend}
              size="small"
              bordered
              scroll={{ x: 'max-content', y: 'calc(100vh - 270px)' }}
              pagination={{
                showSizeChanger: true,
                pageSize: pagesizeIndex,
                total: totalPage, // total record data from database server
                current: currentPage, // current page number
                onChange: onChangePage,
              }}
            />
          )}
        </div>
      </div>

      <Modal
        width={400}
        title="Filter By Date"
        open={openModel}
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="apply" type="primary" onClick={handleApply}>
            Apply
          </Button>,
        ]}
      >
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ margin: 10 }}>
            <p>Start Date : </p>
            <DatePicker
              format="DD/MM/YYYY" // Set the display format
              value={UserDateStart} // Directly use state as DatePicker handles dayjs objects
              onChange={OnChangeDate_Start}
              className="styleDatePicker"
              style={{ width: "150px" }}
              allowClear
            />
          </div>
          <div style={{ margin: 10 }}>
            <p>End Date : </p>
            <DatePicker
              format="DD/MM/YYYY" // Set the display format
              value={UserDateEnd}
              onChange={OnChangeDate_End}
              className="styleDatePicker"
              style={{ width: "150px" }}
              allowClear
            />
          </div>
        </div>
      </Modal>

      <Modal
        width={400}
        open={visableModelAttendance}
        title="New"
        onCancel={() => setVisableModelAttendance(false)}
        footer={[
          <Button key="cancel" onClick={() => setVisableModelAttendance(false)}>
            Cancel
          </Button>,
          <Button key="apply" type="primary" onClick={handleSaveandUpdate}>
            Save Attendance
          </Button>,
        ]}
      >
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ margin: 10 }}>
            <p>Staff Name: </p>
            <Select
              style={{ width: "100%", height: 40 }}
              showSearch
              value={staffname}
              className="styleTageStatusForm"
              placeholder="Select a person"
              optionFilterProp="label"
              onChange={onChangeStaff}
            >
              {list_staff.map((item) => (
                <Option key={item.id} value={item.username}>
                  {item.fullname}
                </Option>
              ))}
            </Select>
            <p style={{ marginTop: 10 }}>Date && Time : </p>
            <Space>
              <DatePicker
                format="DD/MM/YYYY" // Set the display format
                value={userdate_attandance} // Directly use state as DatePicker handles dayjs objects
                onChange={onChangeDateAttendance}
                className="styleDatePicker"
                style={{ width: "150px" }}
                allowClear
              />
              <TimePicker
                className="styleTageStatusForm"
                onOk={onCLickTimeChange}
                defaultValue={dayjs("12:00", format)}
                format={format}
              />
            </Space>
          </div>
        </div>
      </Modal>


      {/* <Modal
        title="ទាញរបាយការណ៍"
        className="custom-modal" // Use the custom-modal class for responsive styles
        open={DownloadReport}
        //   onCancel={onCancelDownload}
        footer={[
          <div>
            <Space>
              <Button
                 color="danger" variant="solid"
                onClick={() => setDownloadReport(false)}
              >
                បោះបង់
              </Button>
              <Button
                className="custom-form-item"
                type="primary"
                onClick={downloadExcel_monthylyreport}
              >
                ទាញយករបាយការណ៍ស្គេនវត្តមាន
              </Button>
 
{
  Boolean(!GetIdnumber) && (
    <Button
      color="purple" 
      variant="solid"
      type="primary"
      onClick={downloadExcel_monthylyreport_calculator}
    >
      គណនាវត្តមាន
    </Button>
  )
}
            </Space>
          </div>,
        ]}
      >
        <div style={{ width: "520px" }}>
          <Space>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <Space style={{ width: "100%" }}>
                ចាប់ពីថ្ងៃទីខែ :
                <DatePicker
                  format="DD/MM/YYYY"
                  onChange={handleDateChange_Start}
                />
              </Space>
            </div>
            <div>
              <Space>
                ដល់ថ្ងៃទីខែ :
                <DatePicker
                  format="DD/MM/YYYY"
                  onChange={handleDateChange_End}
                />
              </Space>
            </div>
          </Space>
          <div style={{ marginTop: 20 }}>
            <Checkbox
              checked={excludeWeekendA}
              onChange={(e) => setExcludeWeekendA(e.target.checked)}
            >
              មិនរាប់អវត្តមាន A (សៅរ៍ នឹងអាទិត្យ)
            </Checkbox>
          </div>
         
        </div>
      </Modal> */}

      <Modal
        title={
          <Space>
            <CalendarOutlined />
            <span>ទាញរបាយការណ៍</span>
          </Space>
        }
        className="custom-modal"
        open={DownloadReport}
        width={700}
        footer={[
          <div key="footer">
            <Space wrap>

              <Button
                danger
                disabled={loading}
                variant="solid"
                icon={<CloseOutlined />}
                onClick={() => {
                  setDownloadReport(false);
                  setDownloadSelectedDepartments([]);
                  setDownloadSelectedStaff([]);
                }}
              >
                បោះបង់
              </Button>
              <Button
                disabled={loading}
                className="custom-form-item"
                type="primary"
                icon={<CalendarOutlined />}
                onClick={handleDownloadDailyReport}
              >
                ទាញយករបាយការណ៍ស្គេនវត្តមាន
              </Button>
              {Boolean(!GetIdnumber) && (
                <Button
                  disabled={loading}
                  color="purple"
                  variant="solid"
                  type="primary"
                  icon={<CheckCircleOutlined />}
                  onClick={() => {
                    downloadExcel_monthylyreport_calculator(downloadSelectedDepartments, downloadSelectedStaff);
                  }}
                >
                  គណនាវត្តមាន
                </Button>
              )}
            </Space>
          </div>,
        ]}
      >
        <div style={{ padding: "10px 0" }}>
          {/* Section 1: Date Range (Required) */}
          <div style={{
            marginBottom: 24,
            padding: "16px",
            backgroundColor: "#fafafa",
            borderRadius: "8px",
            border: "1px solid #e8e8e8"
          }}>
            <div style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "12px",
              gap: "8px"
            }}>
              <div style={{
                backgroundColor: "#1890ff",
                color: "white",
                borderRadius: "50%",
                width: "24px",
                height: "24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "14px",
                fontWeight: "bold",
                flexShrink: 0
              }}>
                1
              </div>
              <CalendarOutlined style={{ color: "#1890ff", fontSize: "18px" }} />
              <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                ជ្រើសរើសកាលបរិច្ឆេទ <span style={{ color: "red" }}>*</span>
              </span>
            </div>

            <div style={{ display: "flex", flexDirection: "row", gap: "20px", flexWrap: "wrap", marginLeft: "32px" }}>
              <div>
                <label style={{ display: "block", marginBottom: "8px", fontWeight: "500" }}>
                  ចាប់ពីថ្ងៃទីខែ :
                </label>
                <DatePicker
                  format="DD/MM/YYYY"
                  onChange={handleDateChange_Start}
                  value={selectedDateStart}
                  style={{ width: "200px" }}
                  placeholder="ជ្រើសរើសថ្ងៃចាប់ផ្តើម"
                />
              </div>
              <div>
                <label style={{ display: "block", marginBottom: "8px", fontWeight: "500" }}>
                  ដល់ថ្ងៃទីខែ :
                </label>
                <DatePicker
                  format="DD/MM/YYYY"
                  onChange={handleDateChange_End}
                  value={selectedDateEnd}
                  style={{ width: "200px" }}
                  placeholder="ជ្រើសរើសថ្ងៃបញ្ចប់"
                />
              </div>
              <div style={{ display: "flex", alignItems: "flex-end", marginBottom: "4px" }}>
                <Checkbox
                  checked={excludeWeekendA}
                  onChange={(e) => setExcludeWeekendA(e.target.checked)}
                >
                  មិនរាប់អវត្តមាន A (សៅរ៍ នឹងអាទិត្យ)
                </Checkbox>
              </div>
            </div>
          </div>

          {/* Section 2: Department Selection (Optional) */}
          {!filter_id_dept && (<div style={{
            marginBottom: 24,
            padding: "16px",
            backgroundColor: "#fafafa",
            borderRadius: "8px",
            border: "1px solid #e8e8e8"
          }}>
            <div style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "12px",
              gap: "8px"
            }}>
              <div style={{
                backgroundColor: "#52c41a",
                color: "white",
                borderRadius: "50%",
                width: "24px",
                height: "24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "14px",
                fontWeight: "bold",
                flexShrink: 0
              }}>
                2
              </div>
              <BankOutlined style={{ color: "#52c41a", fontSize: "18px" }} />
              <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                ជ្រើសរើសនាយកដ្ឋាន
              </span>
              <Tag color="default" style={{ marginLeft: "4px" }}>ជម្រើស</Tag>
            </div>

            <div style={{ marginLeft: "32px" }}>
              <DepartmentList
                selectedDepartments={downloadSelectedDepartments}
                onChange={setDownloadSelectedDepartments}
                placeholder="ស្វែងរក និងជ្រើសរើសនាយកដ្ឋាន..."
                showCode={true}
                multiple={true}
                allowClear={true}
                maxTagCount={5}
                showSelectAll={true}
              />

              {downloadSelectedDepartments.length > 0 && (
                <div style={{
                  marginTop: 8,
                  fontSize: "12px",
                  color: "#52c41a",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px"
                }}>
                  <InfoCircleOutlined />
                  <span>បុគ្គលិកនឹងត្រូវបានតម្រងតាមនាយកដ្ឋានដែលបានជ្រើសរើស</span>
                </div>
              )}
            </div>
          </div>)}

          {/* Section 3: Staff Selection (Optional - Filtered by selected departments) */}
          {!filter_id_dept && (<div style={{

            marginBottom: 16,
            padding: "16px",

            backgroundColor: "#fafafa",
            borderRadius: "8px",
            border: "1px solid #e8e8e8"
          }}>
            <div style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "12px",
              gap: "8px",
              flexWrap: "wrap"
            }}>
              <div style={{
                backgroundColor: "#722ed1",
                color: "white",
                borderRadius: "50%",
                width: "24px",
                height: "24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "14px",
                fontWeight: "bold",
                flexShrink: 0
              }}>
                3
              </div>
              <TeamOutlined style={{ color: "#722ed1", fontSize: "18px" }} />
              <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                ជ្រើសរើសបុគ្គលិក
              </span>
              <Tag color="default">ជម្រើស</Tag>


            </div>

            <div style={{ marginLeft: "32px" }}>
              <StaffList
                selectedStaff={downloadSelectedStaff}
                onChange={setDownloadSelectedStaff}
                placeholder="ស្វែងរក និងជ្រើសរើសបុគ្គលិក..."
                multiple={true}
                allowClear={true}
                maxTagCount={5}
                showAvatar={true}
                showSelectAll={true}
                departmentCode={downloadSelectedDepartments.length > 0 ? downloadSelectedDepartments.join(",") : null}
              />
            </div>
          </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default AttendanceQRCode;
